import Logger from 'services/Logger';

const formatMoney = (amount: number, decimalCount = 2, decimal = '.', thousands = ',') => {
  let newDecimal = decimalCount;
  let newAmount = amount;

  try {
    newDecimal = Math.abs(newDecimal);
    // eslint-disable-next-line no-restricted-globals
    newDecimal = isNaN(newDecimal) ? 2 : newDecimal;

    const negativeSign = amount < 0 ? '-' : '';

    // eslint-disable-next-line radix
    const i = parseInt(
      (newAmount = Math.abs(Number(newAmount) || 0).toFixed(newDecimal))
    ).toString();
    const j = i.length > 3 ? i.length % 3 : 0;

    return (
      negativeSign +
      (j ? i.substring(0, j) + thousands : '') +
      i.substring(j).replace(/(\d{3})(?=\d)/g, `$1${thousands}`) +
      (decimalCount
        ? decimal +
          Math.abs(Math.abs(amount) - i)
            .toFixed(decimalCount)
            .slice(2)
        : '')
    );
  } catch (e) {
    Logger.debug(e);
    return null;
  }
};

export default formatMoney;
